import FourStepComponent from '@/components/four-step-component';
import FourStepBlock from '@/components/four-step-component/four-step-block';
import ProgressBar from '@/components/progress-bar';
import ScoreBanner from '@/components/score-banner';
import ResultsPage from '@/components/results-page';
import ResultsBanner from '@/components/results-page/results-banner';
import KeyClaims from '@/components/key-claims';
import BenefitsList from '@/components/benefits-list';
import BeforeAfterCarousel from '@/components/before-after-carousel';
import ReviewCarousel from '@/components/results-page/review-carousel';
import FragranceSelect from '@/components/regimen/fragrance-select';
import FrequencySelector from '@/components/frequency-selector';
import Loader from '@/components/loader';
import Modal from '@/components/modal';
import AlertModal from '@/components/alert-modal';
import FragranceModal from '@/components/regimen/fragrance-modal';
import CarouselComponent from '@/components/carousel-component';
import LoadingModal from '@/components/loading-modal';
import FlyoutPromo from '@/components/flyout-promo';
import SephoraProducts from '@/components/sephora-products';
import TargetProducts from '@/components/target-products';
import MediaComponent from '@/components/media-component';
import MediaProductCarousel from '@/components/media-product-carousel';
import QuantityInput from '@/components/quantity-input';
import QuantityInputRegimen from '@/components/quantity-input-regimen';
import SubscriptionDetailsCard from './subscription-details-card';
import ProductsCancelledDetails from './products-cancelled-details';
import ChevronButton from '@/components/chevron-button';
import Quiz from '@/components/quiz';
import MiniQuizBasic from '@/components/mini-quiz/mini-quiz-basic';
import AbComponent from '@/components/ab-component';
import BuyOnceRegimen from '@/components/quiz/buy-once-regimen';
import ProductDescription from '@/components/product-description';
import SliderCarousel from '@/components/slider-carousel';
import Accordion from '@/components/accordion';
import AccordionAdvanced from '@/components/accordion-advanced';
import AccordionHeader from '@/components/accordion-advanced/accordion-header';
import AccordionBody from '@/components/accordion-advanced/accordion-body';
import BaseComponent, { defineComponent } from '@/components/base';
import CustomizationDetails from '@/components/customization-details';
import CustomizationSelector from '@/components/customization-details/customization-selector';
import CustomizationMultiSelector from '@/components/customization-details/customization-multi-selector';
import PlanSelector from '@/components/plan-selector';
import ProductExtraDetails from '@/components/product-extra-details';
import QuizContext from '@/components/mini-quiz/quiz-context';
import OrdersContext from '@/components/orders-context';
import CartContext from '@/components/cart-context';
import StaticBanner from '@/components/static-banner';
import FeatureListBanner from '@/components/feature-list-banner';
import ShopAllFilters from '@/components/shop-all-filters';
import MenuComponent from '@/components/menu';
import ProductCard from '@/components/product-card';
import CountDownTimer from '@/components/count-down-timer';
import PromoCard from '@/components/promo-card';

customElements.define('base-component', BaseComponent);
customElements.define('quiz-context', QuizContext);
customElements.define('orders-context', OrdersContext);
customElements.define('cart-context', CartContext);
customElements.define('ab-component', AbComponent);
customElements.define('buy-once-regimen', BuyOnceRegimen);
customElements.define('media-component', MediaComponent);
customElements.define('media-product-carousel', MediaProductCarousel);
customElements.define('fragrance-select', FragranceSelect);
customElements.define('loader-component', Loader);
customElements.define('review-carousel', ReviewCarousel);
customElements.define('results-page', ResultsPage);
customElements.define('results-banner', ResultsBanner);
customElements.define('four-step-module', FourStepComponent);
customElements.define('four-step-block', FourStepBlock);
customElements.define('progress-bar', ProgressBar);
customElements.define('score-banner', ScoreBanner);
customElements.define('key-claims', KeyClaims);
customElements.define('benefits-list', BenefitsList);
customElements.define('before-after-carousel', BeforeAfterCarousel);
customElements.define('frequency-selector', FrequencySelector);
customElements.define('modal-component', Modal);
customElements.define('alert-modal', AlertModal);
customElements.define('fragrance-modal', FragranceModal);
customElements.define('loading-modal', LoadingModal);
customElements.define('carousel-component', CarouselComponent);
customElements.define('flyout-promo', FlyoutPromo);
customElements.define('sephora-products', SephoraProducts);
customElements.define('target-products', TargetProducts);
customElements.define('subscription-details-card', SubscriptionDetailsCard);
customElements.define('products-cancelled-details', ProductsCancelledDetails);
customElements.define('quantity-input', QuantityInput);
customElements.define('quantity-input-regimen', QuantityInputRegimen);
customElements.define('chevron-button', ChevronButton);
customElements.define('slider-carousel', SliderCarousel);

customElements.define('accordion-component', Accordion);
customElements.define('accordion-advanced', AccordionAdvanced);
customElements.define('accordion-header', AccordionHeader);
customElements.define('accordion-body', AccordionBody);
customElements.define('quiz-component', Quiz);
customElements.define('mini-quiz-basic-component', MiniQuizBasic);
customElements.define('product-description-component', ProductDescription);
customElements.define('customization-details', CustomizationDetails);
customElements.define('customization-selector', CustomizationSelector);
customElements.define(
  'customization-multi-selector',
  CustomizationMultiSelector
);
customElements.define('plan-selector', PlanSelector);
customElements.define('product-extra-details', ProductExtraDetails);
customElements.define('static-banner', StaticBanner);
customElements.define('feature-list-banner', FeatureListBanner);
customElements.define('product-card', ProductCard);

customElements.define('shop-all-filters', ShopAllFilters);
defineComponent('menu-component', MenuComponent);
customElements.define('count-down-timer', CountDownTimer);
customElements.define('promo-card', PromoCard);
